var map = {
	"./datetime/ca.json": "4a00",
	"./datetime/de.json": "e424",
	"./datetime/en-GB.json": "cde5",
	"./datetime/en-us.json": "7235",
	"./datetime/es.json": "c0c7",
	"./datetime/eu.json": "2721",
	"./datetime/fr.json": "2346",
	"./datetime/gl.json": "d6f9",
	"./number/ca.json": "b6c6",
	"./number/de.json": "fc9f",
	"./number/en-GB.json": "ea1e",
	"./number/es.json": "6878",
	"./number/eu.json": "e070",
	"./number/fr.json": "a1c5",
	"./number/gl.json": "fa19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c3a7";